import { Store, Module, ActionContext } from 'vuex';
import Ajax from '../../lib/ajax';
import Currency from '../entities/order/currency';
import ListModule from './list-module';
import ListState from './list-state';

interface CurrencyState extends Currency {}

class CurrencyModule {
  namespaced = true;
  state = {
    id: '',
  };

  actions = {
    init(context: ActionContext<CurrencyState, any>, payload: any) {
      if(!window.location.href.includes('currency')){
        if(window.location.origin.includes('ru')){
          localStorage.setItem('lang', 'ru');
          context.state.id = 'RUB';
        }
        else{
          localStorage.setItem('lang', 'en');
          context.state.id = 'EUR';
        }
      }
      else{
 
     
   

       const currencyParamStartIndex = window.location.href.indexOf("currency=");
       if(currencyParamStartIndex!=-1){
        debugger;
        var value = window.location.href.slice(currencyParamStartIndex + 9, currencyParamStartIndex + 12);
        if(value=='EUR'||value=='RUB'||value=='USD'||value=='TRY'){
          context.state.id =value.toUpperCase();
        }
       
        else{
          if(window.location.origin.includes('ru')){
            localStorage.setItem('lang', 'ru');
            context.state.id = 'RUB';
          }
          else{
            localStorage.setItem('lang', 'en');
            context.state.id = 'EUR';
          }
        }

 
       }
       else{
         if(window.location.origin.includes('ru')){
          localStorage.setItem('lang', 'ru');
          context.state.id = 'RUB';
        }
        else{
          localStorage.setItem('lang', 'en');
          context.state.id = 'EUR';
        }
       }

    
      }
     
     
    },
    getCurrency(context: ActionContext<CurrencyState, any>, payload: any) {
      context.state.id = payload.data;
    },
    setCurrency(context, payload) {
      if(payload.data!=undefined){
        context.state.id = payload.data;
      }
    }
  };
  mutations = {
    setCurrency(context, payload) {

    },
  };
}

const currencyModule = new CurrencyModule();
export default currencyModule;
